var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEscClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9,1.9l43.4,43.7c0,0,0.4,1.6-1.7,1.4L1.2,3.6C1.2,3.6,0.8,1.4,2.9,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,6.3L12.5,3c0,0,0.6-1.1,1.7-1.1s18.2,0,18.2,0s1.4-0.2,2.4,1.3l4.6,6.8h2.7c0,0,1.1,0,1.1,1.1c0,0,0,1.1-0.8,1.1H40 c0,0,0.3-0.6-0.4,10.4l0.1,3.4c0,0,0,2.7-2.4,3.2h-4.1c0,0-1.6-1.1-2.1-2.7L31,23.8h-3l-2.4-2.2l11.9-0.1l0.6-9.2l-21.8-0.1 l-2.2-2.4l22.6-0.2l-3.5-5c0,0-0.4-0.5-1.1-0.5L14.5,4L12,7.9L10.3,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,23.7H16v2.5c0,0,0.4,1.9-2.2,2.9l-3.4,0.2c0,0-2.4-1-2.6-2.8L7.4,12.2H4.9c0,0-1.7-1.1,0-2.2h4.7L10,21.6l11,0.1 L22.5,23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10,23.9h4v2c0,0,0.1,0.9-0.7,1.1h-3c0,0-0.4-0.1-0.4-1.3L10,23.9L10,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.6,23.9h4v2c0,0,0.1,0.9-0.7,1.1h-3c0,0-0.4-0.1-0.4-1.3v-1.8H33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1,17.8h-3.8c-0.5,0-0.9-0.4-0.9-0.9v-0.5c0-0.5,0.4-0.9,0.9-0.9h3.8c0.5,0,0.9,0.4,0.9,0.9v0.5 C17,17.4,16.6,17.8,16.1,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9,17.8h-3.8c-0.5,0-0.9-0.4-0.9-0.9v-0.5c0-0.5,0.4-0.9,0.9-0.9h3.8c0.5,0,0.9,0.4,0.9,0.9v0.5 C34.8,17.4,34.4,17.8,33.9,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3,31.8c0,0-0.1-1.4,1.4-0.9c0,0,1.6,0.5,0,2.8c0,0,0.1,0.6-4.7,1.3c0,0-1.6,0.4,1.5,1.7c0,0,4.6,1.8,5.5,3.4 c0,0,2.2,4.1-4.1,6.4c0,0-1.6,0.6-6.5,0.6c0,0-1-1.5,0.4-2.1c7.3-1.1,6.1-0.6,8.1-2.7c0,0,0.8-1.7-2.7-2.7c0,0-5.9-1.7-5.1-4.7 c0,0,0-1.9,3.9-2.4C11.1,32.4,13.2,32.3,13.3,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,31.8c0,0-0.1-1.4,1.4-0.9c0,0,1.6,0.5,0,2.8c0,0,0.1,0.6-4.7,1.3c0,0-1.6,0.4,1.5,1.7c0,0,4.6,1.8,5.5,3.4 c0,0,2.2,4.1-4.1,6.4c0,0-1.6,0.6-6.5,0.6c0,0-1-1.5,0.4-2.1c7.3-1.1,6.1-0.6,8.1-2.7c0,0,0.8-1.7-2.7-2.7c0,0-5.9-1.7-5.1-4.7 c0,0,0-1.9,3.9-2.4C34.7,32.4,36.7,32.3,36.8,31.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscClosed);
export default __webpack_public_path__ + "static/media/ESCClosed.79aba05a0dbce3e332cb176ccc32e646.svg";
export { ForwardRef as ReactComponent };